angular.module('kareo.ui.shared.modules.date.date-filter-config', ['kareo.ui.shared.modules.api.practice-timezone-service'])
    .config(['$provide', function ($provide) {
      $provide.decorator('dateFilter', ['$delegate', 'practiceTimeZoneService', function ($delegate, practiceTimeZoneService) {
        var defaultFilter = $delegate;
        var dateCache = {};
        var timeZoneId;
        practiceTimeZoneService.getPracticeTimeZone()
                .then((data) => {
                  if (data !== null && data.timeZoneId !== null) {
                    timeZoneId = data.timeZoneId;
                    dateCache = {};
                  }
                });

        var customFilter = function (date, format, timezone) {
          var key = date + ',' + format + ',' + timezone;
          if (dateCache[key]) {
            return dateCache[key];
          }

          if (angular.isUndefined(timezone) && timeZoneId) {
            timezone = moment(date).tz(timeZoneId).format('Z') + '';
          } else if (timezone === 'default') {
            timezone = null;
          }
          dateCache[key] = defaultFilter.apply(this, [date, format, timezone]);
          return dateCache[key];
        };
        customFilter.$stateful = true;

        return customFilter;
      }]);
    }]);
